import React from 'react'

import { Field } from 'react-form'

import { Checkbox } from 'primereact/checkbox'

import FieldMessage from './FieldMessage'

import { validateFromRule, getRuleForField } from '../../js/validation'

import '../../css/field.css'

// this ia wrapper function for the prime react checkbox so it can work with react-form's form object
// make sure it is used with Form tags

// the reason this is done is because prime react's components are examples of controlled components
// they have a value set that binds to the state or props so that when that state or props is udated the component is re-rendered
// the onChange of the component needs to be handled to update the value of the state or props otherwise the user input will not be picked up

// this allows the value of the form to read and updated in the form
// pass in the field as the property name to bind and the label as what is displayed
// an optional validate function can be passed in to perform validation
/*
  <Form>
  {formApi => {
      return (
      <form>
          <div className="p-g">
              <div className="p-g-12">
                  <FieldCheckbox field={"PaidServicesProvided"} label={"Paid Services Provided"} />
              </div>
          </div>
      </form>
      )}
  }
  </Form>
*/
class FieldCheckbox extends React.Component {
  render() {
    const { field, ...rest } = this.props
    let id = field
    let idError = field + '_error'

    return (
      // Use the form field and your custom input together to create your very own input!
      // field is the property name that is bound to in the form
      // validate is a function used to validate the field
      <Field field={this.props.field} validate={this.validate}>
        {fieldApi => {
          // fieldApi properties can found at https://react-form.js.org/#/custom-input
          // Remember to pull off everything you dont want ending up on the element otherwise it will throw errors
          // this extracts things out of the props passed in and leaves ...rest to be the rest of the properties
          // this way can pass in the extra properties to the prime react component
          const { field, label, showAsTextOnly, ...rest } = this.props
          // value and setValue read and update value in the form
          const { value, setValue, error, warning, success } = fieldApi
          return (
            <React.Fragment>
              <div className="p-grid" role="group">
                <div className="p-col-12 field-element-container">
                  <Checkbox {...rest} checked={value || false}  aria-describedby={idError} 
                    disabled={showAsTextOnly || rest.disabled}
                    className={showAsTextOnly ? 'show-text-only' : ''}
                    onChange={e => { setValue(e.checked) }} type="checkbox" inputId={id+"Id"} ></Checkbox>
                    <label htmlFor={id+"Id"}>
                      {this.props.label}
                    </label>
                </div>
              </div>
              {(error || warning || success) && <div className="p-col-12">
                {error ? <FieldMessage color="red" message={error} /> : null}
                {!error && warning ? <FieldMessage color="orange" message={warning} id={idError} /> : null}
                {!error && !warning && success ? <FieldMessage color="green" message={success} /> : null}
              </div>}
            </React.Fragment>
          )
        }}
      </Field>
    )
  }

  /*
    generic validation handler for input field
    checks the validation rules
    TODO - optional validation passed in as a props
  */
  validate = value => {
    let validationResult = {}
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
      if (validationRule) {
        validationResult = validateFromRule(validationRule, value)
      }
    } else {
      validationResult.success = ''
    }
    return validationResult
  }
}

export default FieldCheckbox



// WEBPACK FOOTER //
// ./src/components/common/FieldCheckbox.js